export default __webpack_public_path__ + "static/media/NIAS0888.34I-35137_-20229_0.e505837e.jpg";